//* Libraries imports
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/app/store";

//* Component imports
import ApplyTagsModal from "@/components/ui/ApplyTagsModal";

//* Hooks imports
import { useCreateTechinicalHistory } from "@/hooks/techinicals-history/mutations/useCreateTechinicalHistory";
import { useFetchTechinicalHistory } from "@/hooks/techinicals-history/queries/useFetchTechinicalHistory";
import { useDeleteTechinicalHistory } from "@/hooks/techinicals-history/mutations/useDeleteTechinicalHistory";
import { fetchTechinicalById, TechinicalActions } from "./TechinicalSlice";

export default function ApplyTags(props: {
  isOpen: boolean;
  onClose: () => void;
  tecnical?: any;
  clientId?: string;
}) {
  const dispatch = useDispatch<AppDispatch>();

  const techinicalState = useSelector((state: RootState) => state.techinical);
  const currentItem = techinicalState.currentItem;

  const createHistory = useCreateTechinicalHistory();
  const fetchHistory = useFetchTechinicalHistory();
  const deleteHistoryItem = useDeleteTechinicalHistory();

  const loadData = useCallback(async () => {
    if (props.tecnical?._id) {
      await dispatch(fetchTechinicalById(props.tecnical._id));
    }
  }, [dispatch, props.tecnical]);

  useEffect(() => {
    if (props.isOpen) {
      loadData();
    }
    return () => {
      dispatch(TechinicalActions.clearCurrentItem());
    };
  }, [props.isOpen, loadData, dispatch]);

  const handleGenerate = async (
    replacements: any,
    mappingRules: any,
    clientId?: string,
  ) => {
    try {
      const result = await createHistory.create({
        techinicalId: props.tecnical._id,
        clientId: clientId || undefined,
        type: "automatic",
        replacements: replacements,
        mappingRules: mappingRules,
      });

      const url = result?.documentUrl;
      if (url) {
        window.open(url, "_blank");
        if (clientId) {
          fetchHistory.fetchAll({
            techinicalId: props.tecnical._id,
            clientId: clientId,
          });
        }
      }
    } catch (e) {
      console.error("Error generating test document:", e);
      alert("Erro ao gerar documento de teste. Tente novamente.");
    }
  };

  const handleUpload = async (file: File, clientId: string) => {
    await createHistory.create({
      techinicalId: props.tecnical._id,
      clientId: clientId,
      type: "upload",
      file: file,
    });
  };

  const handleHistoryFetch = (filters: {
    clientId?: string;
    type?: "automatic" | "upload";
    startDate?: string;
    endDate?: string;
  }) => {
    if (props.tecnical?._id) {
      fetchHistory.fetchAll({
        techinicalId: props.tecnical._id,
        ...filters,
      });
    }
  };
  console.log("history fetch", fetchHistory);
  return (
    <ApplyTagsModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      entity={currentItem || props.tecnical}
      acceptedFileTypes=".docx"
      onGenerate={handleGenerate}
      onUpload={handleUpload}
      history={{
        items: fetchHistory.items,
        loading: fetchHistory.loading,
        onDelete: async (id) => {
          await deleteHistoryItem.remove(id);
        },
        onFetch: handleHistoryFetch,
      }}
      isGenerating={createHistory.loading}
      title={`Aplicar peça tecnica "${props.tecnical?.name}" em cliente`}
      clientId={props.clientId}
    />
  );
}
